import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "reactstrap";
import _ from "lodash";
import CollapseSection from "../../../commons/collapse/components/collapse-section";

const getSchoolName = (schools, id) => {
  const school = schools.find((option) => option.value === id);
  return school ? school.text : "-";
};

const getSiblingsOptions = (siblings, clientId, placeholder, forConference) =>
  _.orderBy(
    [
      { value: forConference ? null : clientId, text: placeholder },
      ...siblings.map((sibling) => ({
        value: sibling.id,
        text: sibling.clientName
      }))
    ],
    "text",
    "asc"
  );

function SchoolFilter(props) {
  const {
    siblings,
    filters,
    clientId,
    handleClick,
    tabName,
    forConference,
    placeHolderText
  } = props;

  const schoolOptions = getSiblingsOptions(
    siblings,
    forConference ? filters.conferenceId : clientId,
    placeHolderText,
    forConference
  );
  return (
    <CollapseSection
      bodyClassName="filter-collapsible-section school-section"
      sectionName={getSchoolName(
        schoolOptions,
        forConference ? filters.conferenceId : filters.clientId || clientId
      )}
    >
      <>
        {schoolOptions.map((option) => (
          <NavLink
            href="#"
            key={`${tabName}-school-${option.value}-${option.text}`}
            className="menu-filter filter-option"
            tabIndex="0"
            onClick={handleClick(option.value)}
          >
            <span>{option.text}</span>
          </NavLink>
        ))}
      </>
    </CollapseSection>
  );
}

SchoolFilter.defaultProps = {
  placeHolderText: "All Members",
  forConference: false
};

SchoolFilter.propTypes = {
  siblings: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      clientName: PropTypes.string
    })
  ).isRequired,
  filters: PropTypes.shape({
    conferenceId: PropTypes.number,
    clientId: PropTypes.number.isRequired
  }).isRequired,
  clientId: PropTypes.number.isRequired,
  handleClick: PropTypes.func.isRequired,
  forConference: PropTypes.bool,
  placeHolderText: PropTypes.string,
  tabName: PropTypes.string.isRequired
};

export default SchoolFilter;
